<script>
import Layout from '@layouts/main'

import { authComputed } from '@state/helpers'

import ViewNull from './components/ViewNull'
import ViewOrder from './components/ViewOrder'
import ViewNewpay from './components/ViewNewpay'

export default {
  page() {
    return {
      title: this.order.merchant.name,
    }
  },
  components: { Layout, ViewNull, ViewOrder, ViewNewpay },
  props: {
    order: {
      type: Object,
      required: true,
    },
    pageType: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      isModalLoginActive: false,
      loginCallBack: null,
    }
  },
  computed: {
    ...authComputed,
    newebpayCallBack() {
      const callbackData = window.globalData.newebpay;
      return (
        callbackData &&
        callbackData.status !== '{{$status}}' && {
          isSuccess: callbackData.status === 'SUCCESS',
          isExpired: callbackData.status === 'EXPIRED',
          message: callbackData.message || '',
        }
      )
    },
    isNullOrder() {
      return typeof this.order === 'object' && Object.keys(this.order).length === 0
    }
  },
  created() {
    this.$store.dispatch('booking/updateCart')
  },
}
</script>

<template>
  <Layout>
    <ViewNewpay
      v-if="newebpayCallBack"
      :order="order"
      :page-type="pageType"
    />
    <ViewOrder
      v-else-if="!isNullOrder"
      :order="order"
      :page-type="pageType"
    />
    <ViewNull
      v-else
    />
  </Layout>
</template>

